import { Pipe, PipeTransform } from '@angular/core';
import {
	formatDateOrNull,
	formatDateTimeOrNull,
	formatDayOfWeek,
	formatTimeOfDay,
	formatTimeOrNull,
	formatTimeValueOrNull,
	formatDayOfWeekLong,
} from '@siza-staff-care/shared/utils';
import { DateTime } from 'luxon';

@Pipe({
	name: 'scDate',
	standalone: true,
})
export class StaffCareDatePipe implements PipeTransform {
	transform(value: Date | DateTime | undefined): string {
		if (!value) {
			return '';
		}
		return formatDateOrNull(value);
	}
}

//SCS-292
@Pipe({
	name: 'scDayOfWeek',
	standalone: true,
})
export class StaffCareDayOfWeekPipe implements PipeTransform {
	transform(value: Date | DateTime | undefined): string {
		if (!value) {
			return '';
		}
		return formatDayOfWeek(value);
	}
}

@Pipe({
	name: 'scDayOfWeekLong',
	standalone: true,
})
export class StaffCareDayOfWeekLongPipe implements PipeTransform {
	transform(value: Date | DateTime | undefined): string {
		if (!value) {
			return '';
		}
		return formatDayOfWeekLong(value);
	}
}

@Pipe({
	name: 'scDateTime',
	standalone: true,
})
export class StaffCareDateTimePipe implements PipeTransform {
	transform(value: Date | DateTime | string | DateTime, withSeconds = false): string {
		return formatDateTimeOrNull(value, { withSeconds });
	}
}

@Pipe({
	name: 'scTime',
	standalone: true,
})
export class StaffCareTimePipe implements PipeTransform {
	transform(value: Date | DateTime | string, withSeconds = true): string {
		return formatTimeOrNull(value, { withSeconds });
	}
}

@Pipe({
	name: 'scTimeOfDay',
	standalone: true,
})
export class StaffCareTimeOfDayPipe implements PipeTransform {
	transform(value: Date | DateTime): string {
		return formatTimeOfDay(value);
	}
}

@Pipe({
	name: 'scTimeValue',
	standalone: true,
})
export class StaffCareTimeValuePipe implements PipeTransform {
	transform(value: number): string {
		return formatTimeValueOrNull(value);
	}
}
